import { Button, Card, Input } from 'antd';
import React, { useEffect, useRef, useState } from 'react'
import {SearchOutlined } from '@ant-design/icons';
import Highlighter from 'react-highlight-words';
import Table, { ColumnProps } from 'antd/lib/table';
import { Link } from 'react-router-dom';
import { AlertMessages } from '@gtpl/shared-utils/alert-messages';
import { StockService } from '@gtpl/shared-services/procurement';



const ReClassificationView = () => {
    const searchInput = useRef(null);
    const [page, setPage] = React.useState(1);
    const [searchText, setSearchText] = useState(''); 
    const [searchedColumn, setSearchedColumn] = useState('');
    const [reClassification,setReClassification] = useState([])
    const service = new StockService;

    useEffect(()=>{
        getReClassificationView()

    },[])
  


const  getReClassificationView = () =>{
    service.getReclassificationView().then((res)=>{
        if(res.status){
            setReClassification(res.data);
        }else{
            if(res.intlCode){
                AlertMessages.getErrorMessage(res.internalMessage);
            }else{
                AlertMessages.getErrorMessage(res.internalMessage);
  
            }
            setReClassification([]);

        }
    })
    .catch((err) =>{
        AlertMessages.getErrorMessage(err.message);
        setReClassification([]);

    })
}


    function handleSearch(selectedKeys, confirm, dataIndex) {
        confirm();
        setSearchText(selectedKeys[0]);
        setSearchedColumn(dataIndex);
      };
    
      function handleReset(clearFilters) {
        clearFilters();
        setSearchText('');
      };

    const getColumnSearchProps = (dataIndex:string) => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
          <div style={{ padding: 8 }}>
            <Input
              ref={ searchInput }
              placeholder={`Search ${dataIndex}`}
              value={selectedKeys[0]}
              onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
              onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
              style={{ width: 188, marginBottom: 8, display: 'block' }}
            />
            <Button
              type="primary"
              onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
              icon={<SearchOutlined />}
              size="small"
              style={{ width: 90, marginRight: 8 }}
            >
              Search
            </Button>
            <Button onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}>
              Reset
            </Button>
          </div>
        ),
        filterIcon: filtered => (
          <SearchOutlined type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
        ),
        onFilter: (value, record) =>
        record[dataIndex]
        ? record[dataIndex]
           .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
            : false,
        onFilterDropdownVisibleChange: visible => {
          if (visible) {    setTimeout(() => searchInput.current.select());   }
        },
        render: text =>
          text ?(
          searchedColumn === dataIndex ? (
            <Highlighter
              highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
              searchWords={[searchText]}
              autoEscape
              textToHighlight={text.toString()}
            />
          ) :text
          )
          : null
         
      });
    

const columnsSkelton : ColumnProps<any>[]=[
    {
        title: 'S No',
        key: 'sno',
        width: '70px',
        render: (text, object, index) => (page-1) * 10 +(index+1)
      },
      {
        title: 'Conversion Type',
        dataIndex: 'conversionType',
        // responsive: ['lg'],
        sorter: (a, b) => a.conversionType.localeCompare(b.conversionType),
        ...getColumnSearchProps('conversionType')
      },
      {
        title: 'From SaleOrder Number',
        dataIndex: 'fromSaleOrderNumber',
        // responsive: ['lg'],
        sorter: (a, b) => a.fromSaleOrderNumber.localeCompare(b.fromSaleOrderNumber),
        ...getColumnSearchProps('fromSaleOrderNumber')
      },
      {
        title: 'To SaleOrder Number',
        dataIndex: 'toSaleOrderNumber',
        // responsive: ['lg'],
        sorter: (a, b) => a.toSaleOrderNumber.localeCompare(b.toSaleOrderNumber),
        ...getColumnSearchProps('toSaleOrderNumber')
      },
      {
        title: 'From ItemName',
        dataIndex: 'fromItemName',
        // responsive: ['lg'],
        sorter: (a, b) => a.fromItemName.localeCompare(b.fromItemName),
        ...getColumnSearchProps('fromItemName')
      },
      {
        title: 'To ItemName',
        dataIndex: 'toItemName',
        // responsive: ['lg'],
        sorter: (a, b) => a.toItemName.localeCompare(b.toItemName),
        ...getColumnSearchProps('toItemName')
      },
]


  return (
    <div>
        <Card title={<span style={{color:'white'}}>Re-classification view</span>}
    style={{textAlign:'center'}} headStyle={{backgroundColor: '#69c0ff', border: 0 }} extra={<Link to='/packing-product-conversion' ><Button className='panel_button' >Create </Button></Link>}
    
    >
        <br></br>
        <Table
        columns={columnsSkelton}
        dataSource={reClassification} 
        pagination={{
            onChange(current) {
              setPage(current);
            }
          }}/>
    </Card>

    </div>
  )
}

export default ReClassificationView